import Accordion from "../../../../../components/Accordion/Accordion";
import EsperienzeLavorative from "./EsperienzeLavorative";
import DisponibilitaOfferta from "./DisponibilitaOfferta";
import Button from "../../../../../components/Button/Button";
import {useHistory} from "react-router";
import Utils from "../../../../../utils/Utils";
import ModaleAnnulla from "../../../../../components/modaleAnnulla/ModaleAnnulla";
import AnagraficaService from "../../../../../services/AnagraficaService";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import AssistentiService from "../../../../../services/AssistentiService";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../../../../../components/spinner/Spinner";
import React, {useEffect, useState} from "react";

function LavoroDisponibilita(props){

    const esperienzeLavorative = (<div><EsperienzeLavorative/></div>)
    const disponibilitaOfferta = (<div><DisponibilitaOfferta/></div>)
    const history = useHistory()
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const fileReducer = useSelector(state => state.fileReducer)
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const dispatch = useDispatch()
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const [showSpinner, setShowSpinner] = useState(false)

    useEffect(() => {
        if (props.onValidita) props.onValidita(!!validateConferma())
    })

    function onClickButtonAnnulla(){
        let path = sessioneUtente && sessioneUtente.tipoUtente === "01"?"/registro":"/home"
        history.push({
            pathname: path
        })
    }

    function onClickButtonProsegui(){
        setShowSpinner(true)
        let path = sessioneUtente && sessioneUtente.tipoUtente === "01"?"/wizardRegistro":"/profilo"
        if (getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato) {
            modificaWizardProsegui()
        }
        history.push({
            pathname: path,
            steps:[{nome:"1. DATI PERSONALI",codiceStep:"01",cliccabile:true},{nome:"2. LAVORO E DISPONIBILITA'",codiceStep:"02",cliccabile:true},{nome:"3. REQUISITI E CONDIZIONI",codiceStep:"03",cliccabile:false}],
            stepAttivo:"03"
        })
    }

    function modificaWizardProsegui() {
        let json = Utils.rimuoviDateVuote(Utils.removeEmptyObject(createJson()))
        let idAssistente = getAssistente.assistente.idAssistente
        let jsonInsertCandidato = Utils.createJsonInsertCandidato(getAssistente.datiAnagrafici)
        AnagraficaService.modificaCandidato(Utils.removeEmptyValueFromObject(jsonInsertCandidato)).then(resInserimentoCandidato => {
            let idCandidato = resInserimentoCandidato.data.id
            if (sessioneUtente.tipoUtente === "02") {
                AnagraficaService.getCandidato(resInserimentoCandidato.data.id).then(resGetCandidato => {
                    let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(resGetCandidato.data,comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice,false)
                    dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
                    callToModificaAssistente(idAssistente,json, idCandidato)
                }).catch(reason => {
                    console.log("Errore Operation GET Candidato: " + reason)
                    setShowSpinner(false)
                })
            }else{
                AnagraficaService.getCandidato(idCandidato).then(res => {
                    let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(res.data,comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice,false)
                    dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
                    callToModificaAssistente(idAssistente,json, idCandidato)
                }).catch(reason => {
                    console.log("Errore Operation GET Candidato: " + reason)
                    setShowSpinner(false)
                })
            }
        }).catch(reason => {
            console.log("Errore Operation PUT Candidato: " + reason)
            setShowSpinner(false)
        })
    }

    function callToModificaAssistente(idAssistente, json, idCandidato){
        AssistentiService.modificaAssistente(idAssistente, json).then(res => {
            uploadFile(idCandidato)
        }).catch(reason => {
            console.log("Errore Operation PUT Assistente: " + reason)
            setShowSpinner(false)
        })
    }

    function uploadFile(idCandidato){
        let jsonParam = {
            idCandidato: idCandidato,
            documentoIdentita: fileReducer && fileReducer.documentoIdentita ? fileReducer.documentoIdentita : "",
            permessoSoggiorno: fileReducer && fileReducer.permessoSoggiorno ? fileReducer.permessoSoggiorno : "",
            attestati: fileReducer && fileReducer.attestati ? fileReducer.attestati : ""
        }

        AssistentiService.modificaUploadFile(idCandidato, Utils.removeEmptyValueFromObject(jsonParam)).then(res => {
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation Caricamento File: " + reason)
        })

    }


    function createJson() {
        let paramsWizard = {
            idCandidato: getAssistente.assistente && getAssistente.assistente.idCandidato ? getAssistente.assistente.idCandidato : "",
            datiPersonali: {
                infoGenerali: getAssistente.infoGenerali
            },
            lavoroDisponibilita: {
                esperienzeLavorative: getAssistente.esperienzeLavorative,
                disponibilitaOfferta: getAssistente.disponibilitaOfferta
            },
            requisitiCondizioni: {
                requisitiIscrizione: getAssistente.requisitiIscrizione,
                datiPersonali: getAssistente.datiPersonali,
                valutazione: getAssistente.valutazione
            }
        }

        if(getAssistente.disponibilitaOfferta && getAssistente.disponibilitaOfferta.comune && getAssistente.disponibilitaOfferta.comune.length > 0){
            let p = {
                type: "MultiPoint",
                coordinates: []
            }
            getAssistente.disponibilitaOfferta.comune.forEach( c => {
                let coordinatesComune = [c.longitudine,c.latitudine]
                p.coordinates.push(coordinatesComune)
            })
            paramsWizard.lavoroDisponibilita.disponibilitaOfferta.location = p
        }
        return paramsWizard
    }

    function validateConferma(){
        if(getAssistente && getAssistente.esperienzeLavorative){
            let stateEsperienzeLavorative = getAssistente.esperienzeLavorative
            if(!stateEsperienzeLavorative.servizio) return true
        }

        if(getAssistente && getAssistente.disponibilitaOfferta){
            let statedisponibilitaOfferta = getAssistente.disponibilitaOfferta

            if(!statedisponibilitaOfferta.stato ||
                !statedisponibilitaOfferta.disponibilitaSettimanale ||
                (statedisponibilitaOfferta.disponibilitaSettimanale && Utils.validateCheckbox(statedisponibilitaOfferta.disponibilitaSettimanale)) ||
                (   statedisponibilitaOfferta.preferenzaTerritoriale && Utils.validateCheckbox(statedisponibilitaOfferta.preferenzaTerritoriale) &&
                    (!statedisponibilitaOfferta.comune || (statedisponibilitaOfferta.comune && statedisponibilitaOfferta.comune[0] === "")) ||
                    !statedisponibilitaOfferta.preferenzaTerritoriale &&
                    (!statedisponibilitaOfferta.comune || (statedisponibilitaOfferta.comune && statedisponibilitaOfferta.comune[0] === "")))
                ) return true
        }

        if (Utils.dateWizardNonValide(getAssistente, sessioneUtente && sessioneUtente.tipoUtente)) return true
    }

    return (
        <div style={{marginTop:"2rem"}}>
            <Spinner show={showSpinner}/>
            <span style={{fontSize:"24px"}}>Compila Scheda Assistente (2 di 3)</span>
            <div style={{marginTop:"2rem"}}>
                <Accordion
                    id={"AccordionEsperienzeLavorative"}
                    headerText={"Esperienze Lavorative"}
                    accordionBody={esperienzeLavorative}
                />
                <Accordion
                    id={"AccordionDisponibilitaOfferta"}
                    headerText={"Disponibilità Offerta"}
                    accordionBody={disponibilitaOfferta}
                />
            </div>
            <div className={"row"}>
                <div className={"col-6"} style={{textAlign:"left"}}>
                        <Button
                            id={"ButtonAnnulla"}
                            typeButton={"White"}
                            disabled={false}
                            text={"Annulla"}
                            style={{minHeight:"50px",minWidth:"150px"}}
                            dataTarget={"modalModificaUtente"}
                            dataToggle={"modal"}
                            dataBackdrop={"static"}
                            dataKeyboard={false}
                            body={<ModaleAnnulla onClick={onClickButtonAnnulla}/>}
                            header={"Attenzione!"}
                        />

                </div>
                <div className={"col-6"} style={{textAlign:"right"}}>
                    <Button
                        id={"ButtonProsegui"}
                        onClick={onClickButtonProsegui}
                        typeButton={"Blue"}
                        disabled={validateConferma()}
                        text={getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato ? "Salva e prosegui" : "Prosegui"}
                        style={{minHeight:"50px",minWidth:"150px"}}
                    />
                </div>
            </div>
        </div>
    )



}
export default LavoroDisponibilita
